export default __webpack_public_path__ + "static/media/rll-mobile-logo.6954b282.png";